import React, { useState, useRef, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { DateRangePicker } from "@syncfusion/ej2-react-calendars";

import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Sort,
  Filter,
} from "@syncfusion/ej2-react-grids";
import { createElement } from "@syncfusion/ej2-base";
import "./styles/ChangeLog.css";

function ChangeLogByDateComponent(props) {
  //const monthArray = useRef(props.changeLog);
  const open = props.open;
  const [dirty, isDirty] = useState(false);
  const gridComponentRef = useRef();

  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }

  const taskCheckbox =
    typeof settings.changeLogCheckboxSettingsTasks == "string"
      ? settings.changeLogCheckboxSettingsTasks == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsTasks;
  const reqCheckbox =
    typeof settings.changeLogCheckboxSettingsReqs == "string"
      ? settings.changeLogCheckboxSettingsReqs == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsReqs;
  const issueCheckbox =
    typeof settings.changeLogCheckboxSettingsIssues == "string"
      ? settings.changeLogCheckboxSettingsIssues == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsIssues;

  useEffect(() => {
    const col0input = document.getElementById("grid-column0-floptr");
    if (col0input) {
      col0input.setAttribute("hidden", "true");
    }
  }, []);

  function expandCollapse(event) {
    Object.keys(open).forEach((key) => {
      open[key] = event.target.textContent == "Expand All" ? true : false;
    });
    isDirty(!dirty);
  }

  const formattedChangeArray = [];
  if (props.changeArray && props.changeArray.length > 0) {
    props.changeArray.forEach((record) => {
      if (
        (record.entityType == "requirement" && reqCheckbox) ||
        (record.entityType == "issue" && issueCheckbox) ||
        (record.entityType == "task" && taskCheckbox)
      ) {
        const fullName = record.changeMessage.substring(
          0,
          record.changeMessage.indexOf(":c:"),
        );
        const fieldChanged = record.changeMessage.substring(
          record.changeMessage.indexOf(":c:") + 3,
          record.changeMessage.indexOf(":f:"),
        );
        const fromValue =
          record.changeMessage.indexOf(":t:") >= 0
            ? record.changeMessage.substring(
                record.changeMessage.indexOf(":f:") + 3,
                record.changeMessage.indexOf(":t:"),
              )
            : "";
        const toValue =
          record.changeMessage.indexOf(":t:") >= 0
            ? record.changeMessage.substring(
                record.changeMessage.indexOf(":t:") + 3,
                record.changeMessage.indexOf(":o:"),
              )
            : "";

        const partiallyFormattedDate = new Date(
          parseInt(record.dateInMillis) - 1000 * 60 * 60 * 4,
        );
        const formattedDate = partiallyFormattedDate
          .toISOString()
          .substring(0, 10);
        const formattedTime =
          partiallyFormattedDate.toISOString().substring(11, 19) + " ET";

        record = {
          ...record,
          user: fullName,
          field: fieldChanged,
          from: fromValue,
          to: toValue,
          date: formattedDate,
          time: formattedTime,
          datetime: partiallyFormattedDate,
        };
        formattedChangeArray.push(record);
      }
    });
  }

  const dateHeaderTemplate = () => {
    return (
      <div className={props.className}>
        <Typography
          sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}
        >
          Date
        </Typography>
      </div>
    );
  };

  const entityHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        Synopsis
      </Typography>
    );
  };

  const entityIdHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        ID
      </Typography>
    );
  };

  const fieldHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        Field
      </Typography>
    );
  };

  const fromHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        From
      </Typography>
    );
  };

  const toHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        To
      </Typography>
    );
  };

  const userHeaderTemplate = () => {
    return (
      <Typography sx={{ fontWeight: "bold", color: "black", fontSize: "18px" }}>
        By
      </Typography>
    );
  };

  const dateTemplate = (record) => {
    return (
      <>
        <div
          className="changeLogCell"
          style={{
            textWrap: "wrap",
            fontWeight: "bold",
            fontSize: "14px",
          }}
          data-entitytype={record.entityType}
        >
          {record.date}
        </div>
        <div
          className="changeLogCell"
          style={{
            textWrap: "wrap",
            fontWeight: "normal",
            fontSize: "12px",
          }}
          data-entitytype={record.entityType}
        >
          {record.time}
        </div>
      </>
    );
  };

  const entityTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "bold",
          fontSize: "14px",
        }}
        data-index={record.index}
        data-entitytype={record.entityType}
      >
        {record.entityName}
      </div>
    );
  };

  const entityIdTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "normal",
          fontSize: "12px",
        }}
        data-index={record.index}
        data-entitytype={record.entityType}
      >
        {record.entityId}
      </div>
    );
  };

  const fieldTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "bold",
          fontSize: "14px",
        }}
        data-entitytype={record.entityType}
      >
        {record.field}
      </div>
    );
  };
  const fromTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "bold",
          fontSize: "14px",
        }}
        data-entitytype={record.entityType}
      >
        {record.from}
      </div>
    );
  };
  const toTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "bold",
          fontSize: "14px",
        }}
        data-entitytype={record.entityType}
      >
        {record.to}
      </div>
    );
  };
  const byTemplate = (record) => {
    return (
      <div
        className="changeLogCell"
        style={{
          textWrap: "wrap",
          fontWeight: "bold",
          fontSize: "14px",
        }}
        data-entitytype={record.entityType}
      >
        {record.user}
      </div>
    );
  };

  const filterOptions = {
    operators: {
      datetimeOperator: [
        { value: "equal", text: "Between" },
        { value: "notEqual", text: "Between" },
        { value: "greaterThan", text: "Between" },
        { value: "lessThan", text: "Between" },
      ],
    },
    type: "Menu",
  };

  const actionBegin = (args) => {
    if (
      args.requestType === "filtering" &&
      args.currentFilteringColumn === "datetime" &&
      window.customFilter
    ) {
      window["customFilter"] = false;
      var grid = gridComponentRef.current;
      args.columns.push({
        actualFilterValue: {},
        actualOperator: {},
        field: "datetime",
        ignoreAccent: false,
        isForeignKey: false,
        matchCase: false,
        operator: "lessthan",
        predicate: "and",
        uid: grid.getColumnByField(args.currentFilteringColumn).uid,
        value: window["endDate"],
      });
    }
  };

  const customFilter = {
    ui: {
      create: (args) => {
        // flValInput is the DATE field, not the dropdown
        let flValInput = createElement("input");
        args.target.appendChild(flValInput);

        var fdate = [];
        gridComponentRef.current.filterSettings.columns.forEach((col) => {
          if (col.field === "datetime") fdate.push(col.value);
        });
        const daterangepicker = new DateRangePicker({
          change: function (e) {
            if (e != undefined && e.value) {
              var grid = gridComponentRef.current;
              window["startDate"] = e.value[0];
              window["endDate"] = e.value[1];
              window["customFilter"] = true;
              grid.filterByColumn("datetime", "greaterthan", e.value[0]);
            }
          },
        });
        if (fdate.length > 0) {
          daterangepicker.startDate = fdate[0];
          daterangepicker.endDate = fdate[1];
        }
        daterangepicker.appendTo(flValInput);
      },
      read: (args) => {
        args.fltrObj.filterByColumn(
          args.column.field,
          args.operator,
          this.dropInstance.value,
        );
      },

      write: (args) => {
        console.log("write");
      },
    },
  };

  const displayPageTable = (
    <Box
      className="logsBox"
      height="86vh"
      width="98%"
      border="solid 1px"
      padding="20px 10px"
    >
      <GridComponent
        enableStickyHeader={true}
        height="100%"
        dataSource={formattedChangeArray}
        allowSorting={true}
        allowFiltering={true}
        filterSettings={filterOptions}
        cssClass="changeLogGrid"
        actionBegin={actionBegin}
        ref={(grid) => (gridComponentRef.current = grid)}
      >
        <ColumnsDirective>
          <ColumnDirective
            headerTemplate={dateHeaderTemplate}
            template={dateTemplate}
            filter={customFilter}
            type="dateTime"
            field={"datetime"}
            width="50"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={entityIdHeaderTemplate}
            template={entityIdTemplate}
            field={"entityId"}
            width="30"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={entityHeaderTemplate}
            template={entityTemplate}
            field={"entityName"}
            width="120"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={fieldHeaderTemplate}
            template={fieldTemplate}
            field={"field"}
            width="80"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={fromHeaderTemplate}
            template={fromTemplate}
            field={"from"}
            width="100"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={toHeaderTemplate}
            template={toTemplate}
            field={"to"}
            width="100"
            textAlign="Left"
          />
          <ColumnDirective
            headerTemplate={userHeaderTemplate}
            template={byTemplate}
            field={"user"}
            width="60"
            textAlign="Left"
            filter={{ type: "CheckBox" }}
          />
        </ColumnsDirective>
        <Inject services={[Sort, Filter]} />
      </GridComponent>
    </Box>
  );

  return displayPageTable;

  function getWeekName(month, weekStart) {
    const thisYear = new Date().getFullYear();
    const initialDate = new Date();
    initialDate.setFullYear(thisYear);
    initialDate.setMonth(month);
    initialDate.setDate(weekStart);
    initialDate.setDate(initialDate.getDate() + 7);

    const startMonthName = getMonthName(month, "long");
    const endMonthName =
      month == initialDate.getMonth()
        ? ""
        : getMonthName(initialDate.getMonth(), "long");

    const weekName =
      startMonthName +
      " " +
      weekStart +
      " - " +
      endMonthName +
      " " +
      (initialDate.getDate() - 1);
    return weekName;
  }

  function getMonthName(monthIndex, type) {
    let monthName = "";
    switch (parseInt(monthIndex)) {
      case 0:
        monthName = type == "long" ? "January" : "Jan";
        break;
      case 1:
        monthName = type == "long" ? "February" : "Feb";
        break;
      case 2:
        monthName = type == "long" ? "March" : "Mar";
        break;
      case 3:
        monthName = type == "long" ? "April" : "Apr";
        break;
      case 4:
        monthName = type == "long" ? "May" : "May";
        break;
      case 5:
        monthName = type == "long" ? "June" : "Jun";
        break;
      case 6:
        monthName = type == "long" ? "July" : "Jul";
        break;
      case 7:
        monthName = type == "long" ? "August" : "Aug";
        break;
      case 8:
        monthName = type == "long" ? "September" : "Sep";
        break;
      case 9:
        monthName = type == "long" ? "October" : "Oct";
        break;
      case 10:
        monthName = type == "long" ? "November" : "Nov";
        break;
      case 11:
        monthName = type == "long" ? "December" : "Dec";
        break;
    }

    return monthName;
  }
}

export default ChangeLogByDateComponent;

ChangeLogByDateComponent.propTypes = {
  changeLog: PropTypes.array,
  changeArray: PropTypes.array,
  projectname: PropTypes.string,
  handleNewWindow: PropTypes.func,
  handleClick: PropTypes.func,
  handleGroupByChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  open: PropTypes.object,
  className: PropTypes.string,
};

/*
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import ListItemText from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Tooltip from "@mui/material/Tooltip";



  const displayPageNarrative =
    monthArray.current.length > 0 ? (
      <Box
        className="logsBox"
        width="100%"
        border="solid 1px"
        padding="10px 10px"
      >
        <List component="nav">
          <ListItem>
            <ListItemText>
              <span
                className="expandCollapse"
                value={true}
                onClick={expandCollapse}
              >
                Expand All
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span
                className="expandCollapse"
                value={false}
                onClick={expandCollapse}
              >
                Collapse All
              </span>
            </ListItemText>
          </ListItem>
          {monthArray.current.map((monthElem, monthIndex) =>
            (taskCheckbox && monthElem.entityType.indexOf("task") >= 0) ||
            (issueCheckbox && monthElem.entityType.indexOf("issue") >= 0) ||
            (reqCheckbox &&
              monthElem.entityType.indexOf("requirement") >= 0) ? (
              <Fragment key={"month" + monthIndex}>
                <ListItemButton
                  className="groupButton"
                  id={"m" + monthIndex}
                  onClick={props.handleClick}
                >
                  <ListItemText className="monthGroup">
                    Weeks starting in&nbsp;
                    {getMonthName(monthElem.month, "long")}
                  </ListItemText>
                  {open["m" + monthIndex] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse
                  in={open["m" + monthIndex]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="nav">
                    {monthElem.weeks.map((weeksElem, weeksIndex) =>
                      (taskCheckbox &&
                        weeksElem.entityType.indexOf("task") >= 0) ||
                      (issueCheckbox &&
                        weeksElem.entityType.indexOf("issue") >= 0) ||
                      (reqCheckbox &&
                        weeksElem.entityType.indexOf("requirement") >= 0) ? (
                        <Fragment key={"week" + weeksIndex}>
                          <ListItemButton
                            className="groupButton"
                            sx={{ pl: 5 }}
                            id={"m" + monthIndex + "w" + weeksIndex}
                            onClick={props.handleClick}
                          >
                            <ListItemText className="weekGroup">
                              {getWeekName(
                                monthElem.month,
                                weeksElem.weekStarting,
                              )}
                            </ListItemText>
                            {open["m" + monthIndex + "w" + weeksIndex] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={open["m" + monthIndex + "w" + weeksIndex]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="nav">
                              {weeksElem.days.map((daysElem, daysIndex) =>
                                (taskCheckbox &&
                                  daysElem.entityType.indexOf("task") >= 0) ||
                                (issueCheckbox &&
                                  daysElem.entityType.indexOf("issue") >= 0) ||
                                (reqCheckbox &&
                                  daysElem.entityType.indexOf("requirement") >=
                                    0) ? (
                                  <Fragment key={"day" + daysIndex}>
                                    <ListItemButton
                                      className="groupButton"
                                      sx={{ pl: 10 }}
                                      id={
                                        "m" +
                                        monthIndex +
                                        "w" +
                                        weeksIndex +
                                        "d" +
                                        daysIndex
                                      }
                                      onClick={props.handleClick}
                                    >
                                      <ListItemText className="dayGroup">
                                        {getMonthName(monthElem.month, "long") +
                                          " " +
                                          daysElem.date.toString()}
                                      </ListItemText>
                                      {open[
                                        "m" +
                                          monthIndex +
                                          "w" +
                                          weeksIndex +
                                          "d" +
                                          daysIndex
                                      ] ? (
                                        <ExpandLess />
                                      ) : (
                                        <ExpandMore />
                                      )}
                                    </ListItemButton>
                                    <Collapse
                                      in={
                                        open[
                                          "m" +
                                            monthIndex +
                                            "w" +
                                            weeksIndex +
                                            "d" +
                                            daysIndex
                                        ]
                                      }
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <List component="div">
                                        {daysElem.messages.map(
                                          (messageElem, messageIndex) =>
                                            (taskCheckbox &&
                                              messageElem.entityType ==
                                                "task") ||
                                            (issueCheckbox &&
                                              messageElem.entityType ==
                                                "issue") ||
                                            (reqCheckbox &&
                                              messageElem.entityType ==
                                                "requirement") ? (
                                              <Fragment
                                                key={"message" + messageIndex}
                                              >
                                                <ListItemText
                                                  sx={{ pl: 15 }}
                                                  className="logMessage"
                                                >
                                                  <Tooltip
                                                    placement="top-start"
                                                    title={messageElem.entityName.substring(
                                                      0,
                                                      messageElem.entityName.indexOf(
                                                        "|",
                                                      ),
                                                    )}
                                                  >
                                                    <span
                                                      data-entitytype={
                                                        messageElem.entityType
                                                      }
                                                      className="changeLogCell"
                                                    >
                                                      {messageElem.entityName.substring(
                                                        messageElem.entityName.indexOf(
                                                          "|",
                                                        ) + 1,
                                                      )}
                                                      :&nbsp;
                                                    </span>
                                                  </Tooltip>
                                                  {messageElem.message.substring(
                                                    0,
                                                    messageElem.message.indexOf(
                                                      ":c:",
                                                    ),
                                                  )}
                                                  &nbsp;changed&nbsp;
                                                  <span className="changeField">
                                                    {messageElem.message.substring(
                                                      messageElem.message.indexOf(
                                                        ":c:",
                                                      ) + 3,
                                                      messageElem.message.indexOf(
                                                        ":f:",
                                                      ),
                                                    )}
                                                  </span>
                                                  {messageElem.message.substring(
                                                    messageElem.message.indexOf(
                                                      ":c:",
                                                    ) + 3,
                                                    messageElem.message.indexOf(
                                                      ":f:",
                                                    ),
                                                  ) != "Details" ? (
                                                    <span>
                                                      <span>
                                                        &nbsp;from&nbsp;
                                                      </span>
                                                      <span className="changePreviousValue">
                                                        {messageElem.message.substring(
                                                          messageElem.message.indexOf(
                                                            ":f:",
                                                          ) + 3,
                                                          messageElem.message.indexOf(
                                                            ":t:",
                                                          ),
                                                        )}
                                                      </span>
                                                      <span>
                                                        &nbsp;to&nbsp;
                                                      </span>
                                                      <span className="changeNewValue">
                                                        {messageElem.message.substring(
                                                          messageElem.message.indexOf(
                                                            ":t:",
                                                          ) + 3,
                                                          messageElem.message.indexOf(
                                                            ":o:",
                                                          ),
                                                        )}
                                                      </span>
                                                    </span>
                                                  ) : null}
                                                  &nbsp;&nbsp;
                                                  <span className="timestamp">
                                                    {messageElem.message.substring(
                                                      messageElem.message.indexOf(
                                                        ":o:",
                                                      ) + 3,
                                                    )}
                                                  </span>
                                                </ListItemText>
                                              </Fragment>
                                            ) : (
                                              <Fragment
                                                key={"message" + messageIndex}
                                              ></Fragment>
                                            ),
                                        )}
                                      </List>
                                    </Collapse>
                                  </Fragment>
                                ) : (
                                  <Fragment key={"day" + daysIndex}></Fragment>
                                ),
                              )}
                            </List>
                          </Collapse>
                        </Fragment>
                      ) : (
                        <Fragment key={"week" + weeksIndex}></Fragment>
                      ),
                    )}
                  </List>
                </Collapse>
              </Fragment>
            ) : (
              <Fragment key={"month" + monthIndex}></Fragment>
            ),
          )}
        </List>
      </Box>
    ) : (
      ""
    );
*/
